module.exports = __webpack_public_path__ + "img/7.d06231e1.webp";